import React, { Component } from "react";
import { Form, Input, Alert } from "antd";
import _ from "lodash";

import { Button } from "../components";
import { fetchApi } from "../utils";

@Form.create()
class CreateAccountForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmDirty: false,
      message: null,
      isLoading: false
    };
  }
  handleSubmit = async e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        this.setState({
          isLoading: true
        });

        const { profileId } = this.props;
        let message = null;
        const dataPost = {
          key: profileId,
          email: _.get(values, "email"),
          password: _.get(values, "password")
        };

        const result = await fetchApi(
          "booking/agent/register",
          "POST",
          JSON.stringify(dataPost)
        );

        if (_.get(result, "status") === "success") {
          const token = _.get(result, "data.token");
          this.props.onSuccess(token);
        } else {
          message = _.get(result, "message");
        }

        this.setState({
          message,
          isLoading: false
        });
      }
    });
  };

  handleConfirmBlur = e => {
    const { value } = e.target;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  compareToFirstPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && value !== form.getFieldValue("password")) {
      callback("Two passwords that you enter is inconsistent!");
    } else {
      callback();
    }
  };

  validateToNextPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && this.state.confirmDirty) {
      form.validateFields(["confirm"], { force: true });
    }
    callback();
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { message, isLoading } = this.state;
    return (
      <Form onSubmit={this.handleSubmit}>
        {message && (
          <Alert
            message={message}
            type="error"
            showIcon
            style={{ marginBottom: 20 }}
          />
        )}
        <Form.Item>
          {getFieldDecorator("email", {
            rules: [
              {
                type: "email",
                message: "The input is not valid Email"
              },
              {
                required: true,
                message: "Please input your Email"
              }
            ]
          })(<Input placeholder="Email" />)}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator("password", {
            rules: [
              {
                required: true,
                message: "Please input your Password"
              },
              {
                validator: this.validateToNextPassword
              }
            ]
          })(<Input type="password" placeholder="Password" />)}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator("confirm", {
            rules: [
              {
                required: true,
                message: "Please confirm your Password"
              },
              {
                validator: this.compareToFirstPassword
              }
            ]
          })(
            <Input
              type="password"
              placeholder="Confirm Password"
              onBlur={this.handleConfirmBlur}
            />
          )}
        </Form.Item>
        <Form.Item>
          <Button
            className="button-login"
            loading={isLoading}
            type="primary"
            htmlType="submit"
          >
            Register
          </Button>
        </Form.Item>
      </Form>
    );
  }
}

export default CreateAccountForm;



// WEBPACK FOOTER //
// ./src/components/CreateAccountForm.js